// assets/predictive-semantic.js
//
// Jelentés-alapú (szemantikus) TARTALÉK a predictive keresés legördülőjében.
//
// A Shopify natív predictive keresés SZIGORÚ, szó-eleji illesztést végez, ezért a
// magyar összetett/leíró szavakra (pl. "gyógycsavar", "fedőcsavar", "sebgyógyulás")
// gyakran 0 terméket ad — miközben a szó jelentése szerint VAN releváns termék.
// Ilyenkor a keresőoldalon is használt Voyage-végpontból (www.bionika.hu/search/semantic)
// jelentés-alapú találatokat töltünk a legördülőbe, a natív predictive kártyák stílusában.
//
// Alapelv: CSAK akkor lép be, ha a natív predictive 0 terméket talált; ha a végpont nem
// elérhető, lassú vagy üres, csendben nem történik semmi. A natív keresést nem érinti.
(function () {
  if (window.__predictiveSemanticInit) return;
  window.__predictiveSemanticInit = true;

  var ENDPOINT = 'https://www.bionika.hu/search/semantic';
  // Melyik bolt indexéből keressen a végpont (külön HU és EN index).
  var BOLT = 'en';
  var MIN_LEN = 3;       // ennél rövidebb kifejezésre nem kérünk szemantikát
  var DEBOUNCE = 480;    // ms – a natív predictive (kb. 300 ms) így már lefutott
  var MAX = 8;           // ennyi terméket mutatunk
  var TIMEOUT = 6000;    // ms – ennél tovább nem várunk a végpontra
  var cache = {};        // "q|brand" -> results (ismételt kérdés nem hív újra)

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function penz(ar, pn) {
    if (!ar) return '';
    var n = parseFloat(ar);
    if (isNaN(n)) return '';
    return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + (pn && pn !== 'EUR' ? ' ' + pn : ' €');
  }
  // A globalis markaszuro a bionika_brand cookie-ban/BionikaBrand-ben van; a vegpont
  // mas domainen fut, ezert parameterkent kuldjuk (mint a kereso-oldali szemantikus JS).
  function brand() {
    try {
      if (window.BionikaBrand && typeof window.BionikaBrand.get === 'function') {
        return window.BionikaBrand.get() || '';
      }
      var m = document.cookie.match(/(?:^|;\s*)bionika_brand=([^;]*)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }

  function inputOf(dd) {
    var f = dd.closest ? dd.closest('form') : null;
    var i = f ? f.querySelector('input[name="q"]') : null;
    return i || null;
  }
  function queryOf(dd) {
    var i = inputOf(dd);
    return i ? (i.value || '').trim() : '';
  }
  // A NATÍV predictive termek-talalatainak szama (a szemantikus lista NEM szamit bele).
  function dawnProductCount(dd) {
    var list = dd.querySelector('#predictive-search-results-products-list');
    return list ? list.querySelectorAll('.predictive-search__list-item').length : 0;
  }
  function hasSem(dd) { return !!dd.querySelector('.predictive-search__semantic'); }
  function removeSem(dd) {
    var w = dd.querySelector('.bnk-semantic-wrap'); if (w) w.remove();
    var g = dd.querySelector('.predictive-search__semantic'); if (g) g.remove();
  }

  function itemHtml(p) {
    var img = p.image
      ? '<img class="predictive-search__image" src="' + esc(p.image) + '" alt="" width="50" height="50" loading="lazy">'
      : '<span class="predictive-search__image" aria-hidden="true"></span>';
    var price = penz(p.price, p.currency);
    return '<li class="predictive-search__list-item" role="option" aria-selected="false">' +
      '<a class="predictive-search__item predictive-search__item--link predictive-search__item--link-with-thumbnail link link--text" href="/products/' + esc(p.handle) + '" tabindex="-1">' +
        img +
        '<div class="predictive-search__item-content">' +
          '<p class="predictive-search__item-heading predictive-search__item-heading--product">' + esc(p.title) + '</p>' +
          (price ? '<span class="price">' + esc(price) + '</span>' : '') +
        '</div>' +
      '</a></li>';
  }

  function inject(dd, results, heading) {
    removeSem(dd);
    if (!results.length) return;
    var items = results.slice(0, MAX).map(itemHtml).join('');
    var group = document.createElement('div');
    group.className = 'predictive-search__result-group predictive-search__semantic';
    group.innerHTML =
      '<h2 class="predictive-search__heading predictive-search__heading--semantic">' + esc(heading || 'Related by meaning') + '</h2>' +
      '<ul class="predictive-search__results-list bnk-semantic-list" role="group">' + items + '</ul>';

    // Ha van natív talalati-wrapper (pl. csak keresesi javaslatok), a szemantikus csoportot
    // MELLE tesszuk (oszlopkent, a lista racsban); ha semmi sincs (0 minden), sajat sima
    // wrapperben a "Kereses erre: X" gomb ELE — ez NEM results-groups-wrapper, hogy a
    // 30rem-es javaslat-oszlop szabaly ne szoritsa ossze; a lista teljes szelessegben racs.
    var wrapper = dd.querySelector('.predictive-search__results-groups-wrapper:not(.bnk-semantic-wrap)');
    if (wrapper) {
      wrapper.appendChild(group);
    } else {
      var w = document.createElement('div');
      w.className = 'bnk-semantic-wrap';
      w.appendChild(group);
      var container = dd.querySelector('#predictive-search-results') || dd;
      var btn = container.querySelector('.predictive-search__search-for-button');
      if (btn) container.insertBefore(w, btn); else container.appendChild(w);
    }
  }

  // Pontos cikkszám/UDI keresés (≥9 számjegy): a natív predictive NEM keres a
  // variáns-SKU-ban, ezért a suggest.json-t hívjuk EXPLICIT variants.sku mezővel.
  function qIsCode(q) {
    return String(q || '').replace(/[^0-9]/g, '').length >= 9;
  }
  function fetchSku(q, cb) {
    var key = 'sku:' + q;
    if (cache[key] !== undefined) { cb(cache[key]); return; }
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' + MAX +
      '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku';
    fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var ps = ((((d || {}).resources) || {}).results || {}).products || [];
        var res = ps.slice(0, MAX).map(function (p) {
          return { handle: p.handle, title: p.title, image: p.image, price: p.price, currency: cur };
        });
        cache[key] = res;
        cb(res);
      })
      .catch(function () { cb([]); });
  }
  // Útválasztó: kód-keresésnél SKU-lekérés, egyébként jelentés-alapú (Voyage).
  function getResults(q, cb) {
    if (qIsCode(q)) { fetchSku(q, cb); return; }
    // BIONIKA (2026-10-06 natív): jelentés-alapú tartalék KIKAPCSOLVA (csak natív találat).
    cb([]); return;
    fetchSem(q, brand(), cb);
  }

  function fetchSem(q, b, cb) {
    var key = q + '|' + b;
    if (cache[key] !== undefined) { cb(cache[key]); return; }
    var url = ENDPOINT + '?shop=' + BOLT + '&q=' + encodeURIComponent(q) + '&limit=' + MAX;
    if (b) url += '&brand=' + encodeURIComponent(b);
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var to = setTimeout(function () { if (ctrl) ctrl.abort(); }, TIMEOUT);
    fetch(url, ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        clearTimeout(to);
        var res = (d && d.ok && d.results) ? d.results : [];
        cache[key] = res;
        cb(res);
      })
      .catch(function () { clearTimeout(to); cb([]); });
  }

  var OBS = { childList: true, subtree: true };
  // A sajat beszurasunk ne inditsa ujra a megfigyelot (vegtelen ciklus).
  function pause(dd, fn) {
    if (dd.__semObs) dd.__semObs.disconnect();
    try { fn(); } finally { if (dd.__semObs) dd.__semObs.observe(dd, OBS); }
  }

  function onChange(dd) {
    var q = queryOf(dd);
    // Rovid kifejezes VAGY a nativ kereso talalt termeket -> szemantika nem kell.
    if (q.length < MIN_LEN || dawnProductCount(dd) > 0) {
      if (hasSem(dd)) pause(dd, function () { removeSem(dd); });
      clearTimeout(dd.__semTimer);
      dd.__semQ = null;
      return;
    }
    if (dd.__semQ === q && hasSem(dd)) return;   // erre a kifejezesre mar mutatunk
    clearTimeout(dd.__semTimer);
    dd.__semTimer = setTimeout(function () {
      if (queryOf(dd) !== q || dawnProductCount(dd) > 0) return;
      var heading = qIsCode(q) ? 'Results for item number' : 'Related by meaning';
      getResults(q, function (results) {
        if (queryOf(dd) !== q || dawnProductCount(dd) > 0) return;   // kozben valtozott / lett talalat
        pause(dd, function () {
          removeSem(dd);
          if (results.length) { inject(dd, results, heading); dd.__semQ = q; }
          else { dd.__semQ = null; }
        });
      });
    }, DEBOUNCE);
  }

  function attach(dd) {
    if (!dd || dd.__semObs) return;
    var obs = new MutationObserver(function () { onChange(dd); });
    dd.__semObs = obs;
    obs.observe(dd, OBS);
    onChange(dd);
  }
  function scan() {
    var dds = document.querySelectorAll('.predictive-search--header, .predictive-search--search-template');
    for (var i = 0; i < dds.length; i++) attach(dds[i]);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  // PJAX-csere utan az uj tartalomban is beallitjuk a megfigyelest.
  document.addEventListener('bionika:content-swapped', scan);
})();
